module.exports = __webpack_public_path__ + "img/plus.fa594757.svg";